(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slider-videos"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $(".owl-carousel").owlCarousel({
    items:1,
    loop:true,
    autoplay:true,
    autoplayTimeout:sectionDuration,
    autoplayHoverPause:false,
      dots:false, 
      nav:true,
      navText : ['<span class="owl-left"><</span>','<span class="owl-right">></span>'],
      responsive: {
            0: {
            },
            1141: {                
            }
        }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
